// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-button[data-v-26084dc2] {\n  position: relative;\n  text-align: left;\n}\n.login-form[data-v-26084dc2] {\n  margin: 20;\n}\n.btn.disabled[data-v-26084dc2] {\n  background-color: lightgray;\n  opacity: 0.4;\n}\n.code-value[data-v-26084dc2] {\n    flex: 1 1 0;\n    border:1px solid #BFBFBF;\n    background-color: #F5F5F5;\n    text-align:left;\n}\n\n/* md */\n@media (min-width:768px) {\n.login-button[data-v-26084dc2] {\n    text-align: center;\n}\n}\n", ""]);
// Exports
module.exports = exports;
